export const SP_SIZE = 1023
export const PC_SIZE = SP_SIZE + 1

export const BREAK_POINTS = Object.freeze({
  sp: SP_SIZE,
  pc: PC_SIZE,
})
